var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 17.5a5.5 5.5 0 1 0 10.999 0A5.5 5.5 0 0 0 12 17.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.5 15v5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.5 20 15 18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m17.5 20 2.5-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.273 20H3.455c-.386 0-.756-.146-1.029-.405a1.352 1.352 0 0 1-.426-.98V3.385c0-.368.153-.72.426-.98S3.069 2 3.455 2H13.76c.386 0 .756.146 1.028.405l2.785 2.651c.273.26.426.612.426.979v2.888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.99 12.916a.603.603 0 0 1-.665-.036.76.76 0 0 1-.238-.29A.906.906 0 0 1 6 12.2V6.8c0-.137.03-.27.087-.39a.76.76 0 0 1 .238-.29.604.604 0 0 1 .666-.035l4.63 2.701c.114.066.21.168.277.294A.9.9 0 0 1 12 9.5a.9.9 0 0 1-.102.42.736.736 0 0 1-.277.294l-4.63 2.702Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.b5fc069cc125d05271df071d4cebd570.svg";
export { ForwardRef as ReactComponent };